<template>
  <div>
    <div class="row" v-if="canAccess">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-12">
              <div class="card-header">
                <div class="row">
                  <div class="col-md-4">
                    <div><label>Bank Account</label></div>
                    <a-select
                      style="width: 100%"
                      v-model:value="selects.bank"
                      placeholder="เลือก Bank account"
                      :options="selects.banks"
                    />
                  </div>
                  <div class="col-md-4">
                    <div><label>Period</label></div>
                    <a-range-picker
                      v-model:value="period"
                      :format="dateFormat"
                      :ranges="ranges"
                      :disabled-date="disabledDate"
                    />
                  </div>
                  <div class="col-md-2">
                    <div>
                      <label style="color: transparent">No Sale Order</label>
                    </div>
                    <a-checkbox v-model:checked="isNoOrder"
                      >No Sale Order</a-checkbox
                    >
                  </div>
                  <div class="col-md-2">
                    <div><label style="color: transparent">ค้นหา</label></div>
                    <a-button
                      type="primary"
                      :loading="dataLoaded"
                      @click="searchTransaction()"
                    >
                      ค้นหา
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card-body"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="canAccess">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-10">
              <div class="card-header">
                <h4 class="card-title">ผลการค้นหา</h4>
              </div>
            </div>
            <div class="col-2">
              <div class="card-header text-right">
                <a-button class="card-title" shape="round" @click="download(0)">
                  ดาวน์โหลด
                </a-button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <a-table
                      :columns="columns"
                      :data-source="data"
                      :loading="dataLoaded"
                      :scroll="{ x: 1000 }"
                    >
                      <template #status="{ record }">
                        <a-tag
                          :color="record.isActived ? 'success' : 'error'"
                          >{{
                            record.isActived ? "ใช้งาน" : "ไม่ใช้งาน"
                          }}</a-tag
                        >
                      </template>
                      <template #datetime="{ record }">
                        {{ getDateTime(record.dateTime) }}
                      </template>
                      <template #deposit="{ record }">
                        {{ getCurrency(record.deposit) }}
                      </template>
                      <template #action="{ record }">
                        <a href="#" v-if="!record.orderNo" @click="showModal(record.id)">Map SO</a>
                      </template>
                    </a-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="canAccess === false">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <a-result
              status="403"
              title="403"
              sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
            >
              <template #extra>
                <a-button type="primary" @click="goToHome"
                  >กลับหน้าหลัก</a-button
                >
              </template>
            </a-result>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      destroyOnClose="true"
      v-model:visible="visible"
      title="ค้นหา Sales Order"
      width="1000px"
    >
      <div class="row">
        <div class="col-md-3">
          <div><label>Sales Order No.</label></div>

          <a-input
            v-model:value="modal.saleOrderNo"
            placeholder="Sales Order No."
            allow-clear
          />
        </div>
        <div class="col-md-3">
          <div><label>ยอดเงิน</label></div>

          <a-input
            v-model:value="modal.amount"
            placeholder="ยอดเงิน"
            allow-clear
          />
        </div>
        <div class="col-md-3">
          <div><label>Game</label></div>
          <a-select
            v-model:value="modal.game"
            style="width: 100%"
            placeholder="เลือกเกม"
            allow-clear
            v-if="selects.gameLoaded"
            :options="selects.games"
          />
        </div>
        <div class="col-md-3">
          <div><label>Package</label></div>
          <a-select
            v-model:value="modal.package"
            style="width: 100%"
            placeholder="เลือก Package"
            allow-clear
            v-if="selects.packageLoaded"
            :options="selects.packages"
          />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-3">
          <a-button
            type="primary"
            :loading="dataSalesOrderLoaded"
            @click="searchSalesOrder()"
          >
            ค้นหา
          </a-button>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-12">
          <a-table
            :columns="columns_salesorder"
            :data-source="data_salesorder"
            :loading="dataSalesOrderLoaded"
            :scroll="{ x: 800 }"
          >
            <template #status="{ record }">
              <a-tag :color="record.isActived ? 'success' : 'error'">{{
                record.isActived ? "ใช้งาน" : "ไม่ใช้งาน"
              }}</a-tag>
            </template>
            <template #datetime="{ record }">
              {{ getDateTime(record.dateTime) }}
            </template>
            <template #amount="{ record }">
              {{ getCurrency(record.amount) }}
            </template>
            <template #action="{ record }">
              <a href="#"  @click="mapSo(record.id)">เลือก</a>
            </template>
          </a-table>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as configuration from "../../../middleware/configuration";
import * as paymentservice from "../../../services/payment";
import * as gameservice from "../../../services/game";
import * as packageservice from "../../../services/package";
import * as orderservice from "../../../services/order";
import moment from "moment";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    width: 80,
  },
  {
    title: "Bank Account",
    dataIndex: "bankAccount",
    key: "bankAccount",
  },
  {
    title: "DateTime",
    slots: { customRender: "datetime" },
    key: "dateTime",
  },
  {
    title: "Description",
    dataIndex: "detail",
    key: "detail",
  },
  {
    title: "Deposit",
    slots: { customRender: "deposit" },
    key: "deposit",
    align: "right",
  },
  {
    title: "FromBank/Branch",
    dataIndex: "fromBank",
    key: "fromBank",
  },
  {
    title: "Teller Code",
    dataIndex: "tellerCode",
    key: "tellerCode",
  },
  {
    title: "Sales Order",
    dataIndex: "orderNo",
    key: "orderNo",
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    slots: { customRender: "action" },
    width: 150,
  },
];
const columns_salesorder = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    width: 80,
  },
  {
    title: "Sales Order",
    dataIndex: "salesOrder",
    key: "salesOrder",
  },
  {
    title: "DateTime",
    slots: { customRender: "datetime" },
    key: "dateTime",
  },
  {
    title: "Game",
    dataIndex: "game",
    key: "game",
  },
  {
    title: "Package",
    dataIndex: "package",
    key: "package",
  },
  {
    title: "Amount",
    slots: { customRender: "amount" },
    key: "amount",
    align: "right",
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    slots: { customRender: "action" },
    width: 150,
  },
];
export default {
  methods: {
    async getBanks() {
      let res = await paymentservice.getBanksAccount();
      try {
        this.selects.banks = res.data.map((x) => {
          return {
            value: x.bankAccountNo,
            label: x.bankCode + " - " + x.bankAccountNo,
          };
        });
        this.selects.banksLoaded = true;
      } catch (error) {
        console.log(error);
      }
    },
    async getGames() {
      try {
        let res = await gameservice.get("games");
        res.data.map((m) => {
          this.selects.games.push({ value: m.id, label: m.name });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.selects.gameLoaded = true;
      }
    },
    async getPackages() {
      try {
        let res = await packageservice.getAllPackage();
        this.selects.allPackages = res.data;
        res.data.map((m) => {
          this.selects.packages.push({ value: m.id, label: m.name });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.selects.packageLoaded = true;
      }
    },
    async searchTransaction() {
      let startDate = this.period.length > 0 ? this.period[0] : "";
      let endDate = this.period.length > 0 ? this.period[1] : "";
      let req = {
        startDate: startDate,
        endDate: endDate,
        bankAccountNo: this.selects.bank,
        isNoSaleOrder: this.isNoOrder,
      };

      if (!req.bankAccountNo) {
        message.warn("กรุณาเลือก Bank Account");
        return;
      } else if (!req.startDate) {
        message.warn("กรุณาเลือก Period");
        return;
      }

      try {
        this.dataLoaded = true;
        let res = await paymentservice.getBankTransactions(req);
        this.data = res.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.dataLoaded = false;
      }
    },
    async searchSalesOrder() {
      let req = {
        salesOrderNo: this.modal.saleOrderNo,
        amount: this.modal.amount,
        game: this.modal.game,
        package: this.modal.package,
      };
      try {
        this.dataSalesOrderLoaded = true;
        let res = await orderservice.getSalesOrder(req);
        this.data_salesorder = res.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.dataSalesOrderLoaded = false;
      }
    },
    async mapSo(id) {
      let req = {
        orderId: id,
        transactionsId: this.modal.id,
      };
      try {
        let res = await paymentservice.MapSo(req);
        if (res.data) {
          message.success("บันทึกสำเร็จ");
          this.visible = false;
        }
      } catch (error) {
        message.error("บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง");
      } finally {
        await this.searchTransaction();
      }
    },
    async showModal(id) {
      this.modal = {
        id: id,
        saleOrderNo: "",
        amount: "",
        game: null,
        package: null,
      }
      await this.getGames();
      await this.getPackages();
      this.visible = true;
    },
    getCurrency(x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    getDateTime(value) {
      if (value) return moment(value).format("DD/MM/YYYY HH:mm:ss");
      return "";
    },
  },
  data() {
    return {
      columns: columns,
      columns_salesorder: columns_salesorder,
      visible: false,
      uid: "",
      role: "",
      canAccess: null,
      data: [],
      dataLoaded: false,
      data_salesorder: [],
      dataSalesOrderLoaded: false,
      period: "",
      dateFormat: "DD/MM/YYYY",
      ranges: {
        Today: [moment(), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
      },
      isNoOrder: false,
      selects: {
        banksLoaded: false,
        banks: [],
        bank: null,
        games: [],
        gameLoaded: false,
        packages: [],
        allPackages: [],
        packageLoaded: false,
      },
      modal: {
        id: "",
        saleOrderNo: "",
        amount: "",
        orderStatus: "waiting_payment",
        game: null,
        package: null,
      },
    };
  },
  async beforeMount() {
    this.uid = await configuration.getUid();
    let user = await configuration.getIdTokenResult();
    if (user) {
      this.role = user.claims.role;
      if (this.role === "manager" || this.role === "admin") {
        this.canAccess = true;
        await this.getBanks();
      } else {
        this.canAccess = false;
      }
    }
  },
  setup() {
    const disabledDate = (current) => {
      // Can not select days before today and today
      return current && current < moment().add(-3, "M");
    };
    return {
      disabledDate,
    };
  },
};
</script>

<style>
</style>